import { CircuitCreateStepperDataPackageType } from "../circuitCreateStepper";

export const PACKAGE_FEATURES: Record<CircuitCreateStepperDataPackageType, string[]> = {
    'WITHOUT_PRODUCT': ['fixed-itinerary', 'fixed-free-dates', 'no-product', 'room-type', 'pension-type', 'package-stock', 'manual-price', 'variants', 'version'],
    'WITH_PRODUCT': ['fixed-itinerary', 'fixed-free-dates', 'xml-products', 'offline-products', 'offline-product-stock', 'package-stock', 'auto-price', 'manual-price', 'auto-manual-mix', 'variants', 'version'],
    'DYNAMIC': ['fixed-itinerary', 'fixed-free-dates', 'xml-products', 'offline-products', 'offline-product-stock', 'auto-price', 'no-alternative-search', 'variants', 'version'],
    'SKELETON_PACKAGE': ['fixed-itinerary', 'fixed-free-dates', 'xml-products', 'offline-products', 'offline-product-stock', 'package-stock', 'skeleton-stock', 'auto-price', 'manual-price', 'auto-manual-mix', 'variants', 'version'],
    'UNKNOWN': []
};

export const getPackageFeatureKeys = (package_type: CircuitCreateStepperDataPackageType): string[] => {
    return PACKAGE_FEATURES[package_type] || [];
};


export const allPackageFeatureKeys = Object.values(PACKAGE_FEATURES).reduce((acc, features) => {
    features.forEach(feature => acc.add(feature));
    return acc;
}, new Set<string>());